import { IBodyAssessmentAction, IBodyAssessmentState } from './bodyAssessment.types'
import { BodyAssessmentConstants } from './bodyAssessment.constants'

export const initialBodyAssessmentState: IBodyAssessmentState = {
  selectedExam: '',
  showExamModal: false,
  bodySelectionMode: { id: 1, name: 'Body parts' },
}

export function bodyAssessmentReducer(
  state: IBodyAssessmentState = initialBodyAssessmentState,
  action: IBodyAssessmentAction
): IBodyAssessmentState {
  switch (action.type) {
    case BodyAssessmentConstants.SET_SELECTED_EXAM:
      return { ...state, selectedExam: action.selectedExam }
    case BodyAssessmentConstants.SET_SHOW_EXAM_MODAL:
      return { ...state, showExamModal: action.showExamModal }
    case BodyAssessmentConstants.SET_BODY_SELECTION_MODE:
      return { ...state, bodySelectionMode: action.bodySelectionMode }
    case BodyAssessmentConstants.RESET_BODY_ASSESSMENT_STATE:
      return { ...initialBodyAssessmentState }
    default:
      return state
  }
}
